import "./IconEye.scss";

type Props = {
  color?: "black" | "white" | "blue";
};

export const IconEye = ({ color = "black" }: Props) => {
  return <span className={`icon-eye icon-eye--${color}`}></span>;
};
